// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"Q0-z"};